<template>
  <v-form
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
    enctype="multipart/form-data"
    lazy-validation
  >
    <v-card :class="{ ['elevation-12']: $vuetify.breakpoint.smAndUp }">
      <v-card-title class="display-1">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="value.date"
          :rules="[$rules.required, $rules.date]"
          :autofocus="$vuetify.breakpoint.smAndUp"
          label="Datum"
          type="date"
          box
        ></v-text-field>
        <v-text-field
          v-model="value.title"
          :rules="[$rules.required]"
          label="Titel"
          box
        ></v-text-field>
        <v-text-field
          v-model="value.publishingDatetime"
          :rules="[$rules.datetime]"
          type="datetime-local"
          label="Veröffentlicht per"
          box
        ></v-text-field>
        <v-autocomplete
          v-model="value.businesses"
          :items="businesses"
          item-text="numberAndTitle"
          item-value="id"
          label="Geschäfte"
          multiple
          chips
          box
        ></v-autocomplete>

        <v-checkbox
          v-if="value.id"
          v-model="value.delete_agenda"
          label="Traktandenliste löschen"
        />
        <FileInput
          v-model="value.agenda_id"
          label="Traktandenliste"
          class="mb-4"
        ></FileInput>
        <v-checkbox
          v-if="value.id"
          v-model="value.delete_protocol"
          label="Protokoll löschen"
        />
        <FileInput
          v-model="value.protocol_id"
          label="Protokoll"
          class="mb-4"
        ></FileInput>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="!valid"
          type="submit"
          color="primary"
          depressed
        >
          {{ submitText }}
        </v-btn>
        <v-btn
          :to="backLink"
          depressed
        >Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import Business from '@/models/business';

export default {
  name: 'SessionForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: () => '',
    },
    submitText: {
      type: String,
      default: () => 'speichern',
    },
    backLink: {
      type: Object,
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      businesses: Business.query().orderBy('modified', 'desc').all(),
      valid: true,
      fileHint: this.edit ? 'Feld leer lassen, wenn keine Änderung vorgenommen werden soll' : null,
      fileRules: this.edit ? [] : [this.$rules.required],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit');
      }
    },
  },
  watch: {
    'value.date': {
      handler(val) {
        if (val && !this.value.title && new Date(val).getTime() > 0) {
          const formatted = this.$options.filters.toLocaleDateString(val);
          this.value.title = `Session vom ${formatted}`;
        }
      },
    },
  },
};
</script>
